import { debugLogReducer } from "../helpers/debugHelper";
import { types } from "../types/types";

const initialState = {

  alternatives: [],

  alternative: {},
  alternativeSaved: {},
  alternativeSelected: {},

  alternativesP: [],
  totalItemsAlternativeP: 0,
  totalPagesAlternativeP: 0,
  currentPageAlternativeP: 0,

  alternativesS: [],
  totalItemsAlternativeS: 0,
  totalPagesAlternativeS: 0,
  currentPageAlternativeS: 0,

  searchTextState: "",

  moreThanOneIsSelected: false,
  numberAlternativeSelected: 0,

  isLoadingAlternatives: false
};

const countSelected = (list) => list.filter(item => item.isSelected).length;

export const alternativeReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ALTERNATIVE_START_REGISTER_ADMIN:

      return {
        ...state,
        alternativeSaved: action.payload,
      };

    case types.ALTERNATIVE_UPDATE:
      if (state.alternativesS.length > 0) {
        return {
          ...state,
          alternativesS: state.alternativesS.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
          alternativesP: state.alternativesP.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
        };
      } else {
        return {
          ...state,
          alternativesP: state.alternativesP.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
        };
      }

    case types.ALTERNATIVE_DELETE:
      if (state.alternativesS.length > 0) {
        return {
          ...state,
          alternativesS: state.alternativesS.filter((usr) => usr.id !== action.payload),
          alternativesP: state.alternativesP.filter((usr) => usr.id !== action.payload),
          alternativeSelected: {},
        };
      } else {
        return {
          ...state,
          alternativesP: state.alternativesP.filter((usr) => usr.id !== action.payload),
          alternativeSelected: {},
        };
      }

    case types.ALTERNATIVE_START_LOADING_PAGINATED:
      return {
        ...state,
        alternativesP: action.payload.alternativesP,
        totalItemsAlternativeP: action.payload.totalItems,
        totalPagesAlternativeP: action.payload.totalPages,
        currentPageAlternativeP: action.payload.currentPage,
      };

    case types.ALTERNATIVE_START_LOADING_ALTERNATIVE_PAGINATED:

      return {
        ...state,
        alternativesS: action.payload.alternativesP,
        totalItemsAlternativeS: action.payload.totalItems,
        totalPagesAlternativeS: action.payload.totalPages,
        currentPageAlternativeS: action.payload.currentPage,
      };

    case types.ALTERNATIVE_START_SEARCH_PAGINATED:
      return {
        ...state,
        alternativesS: action.payload.alternativesP,
        totalItemsAlternativeS: action.payload.totalItems,
        totalPagesAlternativeS: action.payload.totalPages,
        currentPageAlternativeS: action.payload.currentPage,
      };

    case types.ALTERNATIVE_SELECT:
      return {
        ...state,
        alternativeSelected: action.payload,
      };

    case types.ALTERNATIVE_CLEAN_SEARCH_PAGINATED:
      return {
        ...state,
        alternativesS: [],
        totalItemsAlternativeS: 0,
        totalPagesAlternativeS: 0,
        currentPageAlternativeS: 0,

        numberAlternativeSelected: 0
      };

    case types.ALTERNATIVE_CLEAN_PAGINATED:
      return {
        ...state,
        alternativesP: [],
        totalItemsAlternativeP: 0,
        totalPagesAlternativeP: 0,
        currentPageAlternativeP: 0,

      };

    case types.ALTERNATIVE_SET_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: action.payload,
      };

    case types.ALTERNATIVE_CLEAN_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: "",
      };

    case types.ALTERNATIVE_CLEAN_SAVED:
      return {
        ...state,
        alternativeSaved: {},
      };

    /*
  case types.ALTERNATIVE_LIST_UPDATE_SELECTED:
    
    if (state.alternativesS.length > 0) {
      return {
        ...state,
        alternativesS: state.alternativesS.map((usr) => (usr.id === action.payload ? { ...usr, isSelected: !usr.isSelected } : usr)),

      };
    }
    break;
    */
    case types.ALTERNATIVE_LIST_UPDATE_SELECTED: {
      const id = action.payload;
      const currentSelectedCount = countSelected(state.alternativesS);
      const targetItem = state.alternativesS.find(item => item.id === id);

      // Si va a seleccionar uno nuevo y ya hay 9, no hacer nada
      if (!targetItem.isSelected && currentSelectedCount >= 9) return state;

      const newAlternatives = state.alternativesS.map(item =>
        item.id === id ? { ...item, isSelected: !item.isSelected } : item
      );

      const newCount = countSelected(newAlternatives);

      return {
        ...state,
        alternativesS: newAlternatives,
        numberAlternativeSelected: newCount,
        moreThanOneIsSelected: newCount > 1
      };
    }

    // Selección masiva (Primeros 9 o todos si hay menos)
    case types.ALTERNATIVE_SELECT_ALL_LIMIT: {
      const newAlternatives = state.alternativesS.map((item, index) => ({
        ...item,
        isSelected: index < 9 // Selecciona solo los primeros 9
      }));

      const newCount = countSelected(newAlternatives);

      return {
        ...state,
        alternativesS: newAlternatives,
        numberAlternativeSelected: newCount,
        moreThanOneIsSelected: newCount > 1
      };
    }

    // Limpiar todo
    case types.ALTERNATIVE_CLEAN_ALL_SELECTED: {
      return {
        ...state,
        alternativesS: state.alternativesS.map(item => ({ ...item, isSelected: false })),
        numberAlternativeSelected: 0,
        moreThanOneIsSelected: false
      };
    }

    //Clean Without list
    case types.ALTERNATIVE_CLEAN_ALL_WITHOUT_LIST: {
      return {
        ...state,
        numberAlternativeSelected: 0,
        moreThanOneIsSelected: false
      };
    }

    case types.ALTERNATIVE_GET_MORE_THAN_ONE_SELECTED:

      debugLogReducer(":: ALTERNATIVE_GET_MORE_THAN_ONE_SELECTED");

      if (state.alternativesS.length > 0) {
        return {
          ...state,
          moreThanOneIsSelected: getMoreThanOneIsSelected(state)
        };
      }
      break;

    case types.ALTERNATIVE_LIST_SET_NUMBER_SELECTED:

      debugLogReducer(":: ALTERNATIVE_LIST_SET_NUMBER_SELECTED");

      if (state.alternativesS.length > 0) {
        return {
          ...state,
          numberAlternativeSelected: action.payload
        };
      }
      break;

    case types.ALTERNATIVE_CLEAN_SEARCH_INFORMATION:

      debugLogReducer(":: ALTERNATIVE_CLEAN_SEARCH_INFORMATION");

      return {
        ...state,
        numberAlternativeSelected: 0
      };

    case types.ALTERNATIVE_IS_LOADING:

      return {
        ...state,
        isLoadingAlternatives: true
      };

    case types.ALTERNATIVE_IS_LOADING_FINISH:

      return {
        ...state,
        isLoadingAlternatives: false
      };

    default:
      return state;
  }
};

const getMoreThanOneIsSelected = (state) => {

  debugLogReducer(":: getMoreThanOneIsSelected");

  let flagMoreThanOne = false;
  let counterFlagMoreThanOneIsSelected = 0;

  if (state.alternativesS.length > 0) {
    state.alternativesS.forEach(element => {

      if (element.isSelected) {
        counterFlagMoreThanOneIsSelected = counterFlagMoreThanOneIsSelected + 1;
      }
    });
  }

  if (counterFlagMoreThanOneIsSelected > 1) {
    flagMoreThanOne = true;
  }

  return flagMoreThanOne;
}